window.AseguraGoConstants = {
    ASEGURAGO_SHOW_LOADER_EVENT: "asegurago_show_loader_event",
    ASEGURAGO_CALLME_FORM_SUBMITED_EVENT: "asegurago_callme_form_submited_event",
    ASEGURAGO_CONTACT_PHONE_EVENT: "asegurago_contact_phone_event",
    ASEGURAGO_HIDE_LOADER_EVENT: "asegurago_hide_loader_event",
    PHONE_PREFIX: '+34'
}